import client from "/src/services/client.js";

export default {
    getKnowledge: (id, params = {}) => client.get("rag/knowledge", { brain_id: id, ...params }),
    deleteKnowledge: (knowledgeId, brainId) => client.delete(`rag/knowledge/${knowledgeId}`, { brain_id: brainId }),
    uploadKnowledge: (bulkId, brainId, formData) =>
        client.post(`rag/upload?bulk_id=${bulkId}&brain_id=${brainId}`, formData),

    crawlWebsite: (bulkId, brainId, crawlOptions) =>
        client.post(`rag/crawl?bulk_id=${bulkId}&brain_id=${brainId}`, { crawlOptions }),
    downloadKnowledge: (knowledgeId) => client.get(`rag/knowledge/${knowledgeId}/signed_download_url`),
};
